import { ApiClientService } from './ApiClientService';

export type UserTheme = {
  title: string | null;
  titleColor: string;
  titleBackgroundColor: string;
  yellowThemeColor: string;
  yellowThemeText: string;
  blueThemeColor: string;
  blueThemeText: string;
  redThemeColor: string;
  redThemeText: string;
  panelTitleColor: string;
  panelColor: string;
};

const emptyTheme: UserTheme = {
  title: null,
  titleColor: '',
  titleBackgroundColor: '',
  yellowThemeColor: '',
  yellowThemeText: '',
  blueThemeColor: '',
  blueThemeText: '',
  redThemeColor: '',
  redThemeText: '',
  panelTitleColor: '',
  panelColor: '',
};

export const getUserTheme = async (): Promise<UserTheme> => {
  const response = await ApiClientService.getJson<Partial<UserTheme>>(
    `${ApiClientService.getApiBaseUrl()}/themes`
  );

  return {
    title: response.title ?? null,
    titleColor: response.titleColor ?? '',
    titleBackgroundColor: response.titleBackgroundColor ?? '',
    yellowThemeColor: response.yellowThemeColor ?? '',
    yellowThemeText: response.yellowThemeText ?? '',
    blueThemeColor: response.blueThemeColor ?? '',
    blueThemeText: response.blueThemeText ?? '',
    redThemeColor: response.redThemeColor ?? '',
    redThemeText: response.redThemeText ?? '',
    panelTitleColor: response.panelTitleColor ?? '',
    panelColor: response.panelColor ?? '',
  };
};

export const updateUserTheme = async (theme: UserTheme): Promise<UserTheme> => {
  const response = await ApiClientService.putJson<Partial<UserTheme>>(
    `${ApiClientService.getApiBaseUrl()}/themes`,
    theme
  );

  return {
    ...emptyTheme,
    ...response,
    title: response.title ?? null,
  };
};
